import styled from "styled-components";
import { colours } from "../../styles/colours.constants";
import { satoshi500 } from "../../styles/font.constants";

export default styled.input`
	width: 100%;
	border-radius: 0.5rem;
	outline: none;
	appearance: none;
	border-style: solid;
	border-width: 2px;
	border-color: ${colours.greyDark};
	padding: 0.6rem;
	color: ${colours.black}D9;
	font-size: 1.1rem;
	${satoshi500}
	letter-spacing: 4%;
	&::placeholder {
		color: ${colours.black}60;
	}
`;
